import {
  ArrowUturnLeftIcon,
  CheckIcon,
  Cog8ToothIcon,
  DocumentTextIcon,
  ViewColumnsIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import { inject, observer } from 'mobx-react';

import Grid from './components/Grid';
import HeaderSection from './components/HeaderSection';
import Tool from './components/Tool';
import ToolDiv from './components/ToolDiv';
import ToolForm from './components/ToolForm';

const MyProfilePage = inject('store')(
  observer(({ store }) => {
    return (
      <>
        <HeaderSection
          categorie="Profile"
          textColor="raisin-black"
          borderColor="platinum"
        />
        <Grid>
          <Tool
            Icon={Cog8ToothIcon}
            title={'Settings'}
            desc={'Get control of your profile and personalize it'}
            to={'/user-settings'}
            fromColor="nue-blue"
            toColor="cool-gray"
          />
          <Tool
            Icon={UserCircleIcon}
            title={'My Avatar'}
            desc={'Design your own avatar and have fun with it'}
            to={'/my-avatar'}
            fromColor="nue-blue"
            toColor="cool-gray"
          />
        </Grid>
        <HeaderSection
          categorie="Membership"
          textColor="raisin-black"
          borderColor="platinum"
        />
        <Grid>
          <Tool
            Icon={ViewColumnsIcon}
            title={'Subscriptions'}
            api={store.api}
            desc={'Choose or update your plan and billing mode'}
            to={'/my-profile/pricing'}
            fromColor="nue-blue"
          />

          {store.profile.scope === 'general' ? (
            <ToolForm
              Icon={DocumentTextIcon}
              title={'Stripe Account'}
              api={store.api}
              desc={
                'Update card details, check invoices, or cancel the plan anytime'
              }
              to={store.baseURL + 'user/stripe/customer-portal'}
              fromColor={'nue-blue'}
              toColor={'nue-blue'}
            />
          ) : null}

          {store.profile.plan !== 'free' &&
            (store.profile.status === 'active' ||
              store.profile.status === 'trialing') &&
            store.profile.scope === 'general' && (
              <ToolForm
                Icon={XCircleIcon}
                title={'Cancel Plan'}
                api={store.api}
                desc={
                  'Immediate cancellation of your subscription and payments'
                }
                to={store.baseURL + 'user/stripe/cancel'}
                fromColor={'nue-blue'}
                toColor={'nue-blue'}
                showConfirm={store.profile.status === 'trialing'}
              />
            )}

          {store.profile.status === 'canceled' &&
            store.profile.scope === 'general' && (
              <ToolForm
                Icon={CheckIcon}
                title={'Reactivate Plan'}
                api={store.api}
                desc={'Immediate activation of your subscription and payments'}
                to={store.baseURL + 'user/stripe/uncancel'}
                fromColor={'nue-blue'}
                toColor={'nue-blue'}
              />
            )}
        </Grid>
        <HeaderSection
          categorie="Platform"
          textColor="raisin-black"
          borderColor="platinum"
        />
        <Grid>
          <ToolDiv
            Icon={ArrowUturnLeftIcon}
            title={'Log Out'}
            desc={'Sign out of your account'}
            onClick={store.handleLogout}
            fromColor="nue-blue"
            toColor="nue-blue"
          />
        </Grid>
      </>
    );
  })
);

export default MyProfilePage;
